const ready = () => {
	require('what-input');
	require('./module/links');
	require('./module/polyfills');
	require('./vue/app');
	require('./plugin/headroom');
	require('./module/site-header');
	require('./module/site-nav');
	require('./module/hero-slider');
	require('./module/products-slider');
	require('./module/intro');
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', ready);
} else {
	ready();
}


// WEBPACK FOOTER //
// ./src/js/site.js